import { Loader } from '@monavate/ui-core';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const LoaderContainer = styled.div`
    width: 100%;
`;

const LoadingScreen: React.FunctionComponent = () => (
    <Wrapper>
        <LoaderContainer>
            <Loader text={'Loading...'} />
        </LoaderContainer>
    </Wrapper>
);

export default LoadingScreen;
